import { useRequiredParams } from '@pba/react-router';
import { AppLayout } from 'layouts';
import { PollDetail } from 'features/feed';

type RouteParams = {
  postId: string;
};

const PagePoll = () => {
  const { postId } = useRequiredParams<RouteParams>();

  return (
    <AppLayout aside>
      <PollDetail postId={postId} />
    </AppLayout>
  );
};

export default PagePoll;
